// ⚙️ Configuration Firebase — projet `koinonia-7f3f3`, créé le 7 août 2026.
//
// Ces six valeurs ne sont PAS des secrets : elles voyagent dans toute
// application web et Google les publie comme telles. Ce qui protège la base,
// ce sont `firestore.rules` et `storage.rules`. Une clé exposée sans règles
// déployées, c'est une porte ouverte ; des règles déployées rendent la clé
// inoffensive.
//
// Services activés côté console :
//   • Authentication — E-mail/Mot de passe (lien magique désactivé)
//   • Firestore      — base (default), multi-région eur3 (Europe)
//   • Storage        — gs://koinonia-7f3f3.firebasestorage.app, Europe
//
// L'emplacement européen est un choix, pas un hasard : l'application collecte
// une photo d'attestation de baptême, donc une donnée sur la religion.

window.FIREBASE_CONFIG = {
  apiKey: "AIzaSyBxlWtWRBcP0iTahtzECAigEYojNx0aDTA",
  /* ⚠️ BASCULÉ SUR LE DOMAINE PROPRE LE 19 AOÛT 2026, le jour où le registre
     .bj a levé le `serverHold` posé le 17. C'est ce domaine qui s'affiche dans
     les COURRIELS de vérification et de réinitialisation — un membre y lisait
     jusqu'ici « koinonia-7f3f3.firebaseapp.com », adresse qu'aucun de ses amis
     n'aurait reconnue, sur un courriel qui lui demande son mot de passe.

     ⚠️ RIEN NE DOIT ÊTRE BASCULÉ ICI TANT QUE LE DOMAINE N'EST PAS DANS LES
     DOMAINES AUTORISÉS de Firebase Auth. Sans cela, Firebase refuse l'adresse
     de retour (`auth/unauthorized-continue-uri`) et PLUS AUCUN courriel ne
     part. Vérifié avant le changement : koinonia.bj y figure en « Custom », et
     `koinonia.bj/__/auth/handler` répond 200. */
  authDomain: "koinonia.bj",
  projectId: "koinonia-7f3f3",
  storageBucket: "koinonia-7f3f3.firebasestorage.app",
  messagingSenderId: "231984843086",
  appId: "1:231984843086:web:f280df6697c31d3517761f",

  /* App Check — la clé de site reCAPTCHA, posée le 13 août 2026.

     ⚠️ C'est une clé ENTERPRISE, pas une v3 classique — le formulaire de Google
     n'en crée plus d'autres. `js/firebase.js` la consomme donc avec
     `ReCaptchaEnterpriseProvider`, et la console Firebase doit l'enregistrer
     sous « reCAPTCHA Enterprise ». Enregistrée sous « reCAPTCHA v3 », l'échange
     répond 400 et rien n'est attesté.
     Elle est publique par nature : elle vit dans le code de la page, comme la
     clé Firebase au-dessus. Ce qui est secret, c'est l'autre clé — celle que
     reCAPTCHA appelle « clé secrète » — et elle ne vit que dans la console
     Firebase, jamais ici.

     ⚠️ EN OBSERVATION, PAS EN APPLICATION FORCÉE. reCAPTCHA n'atteste que les
     domaines déclarés, et l'application du téléphone sert ses pages depuis
     `https://localhost` — un domaine qu'on ne peut pas déclarer chez Google.
     Activer l'application forcée dans la console COUPERAIT le téléphone. En
     observation, App Check compte les requêtes non attestées sans rien bloquer,
     ce qui est déjà l'essentiel : on voit qui frappe à la porte.

     Et si l'attestation échoue, `js/firebase.js` l'avale : une application qui
     se fermerait à ses membres parce que Google a hoqueté serait pire que le
     problème qu'on cherche à résoudre. */
  appCheckKey: "6LfuQoQtAAAAAABTgnYkRWWdLDoRF444QLPpG59V",
};

// Les comptes de démonstration n'existent qu'en mode local. Dès que la
// configuration ci-dessus est remplie, l'application passe en mode Firebase et
// cette graine n'est plus semée — mais on la coupe explicitement, pour qu'un
// retour en arrière ne recrée jamais de faux comptes en production.
window.DEMO_SEED = false;
